"use strict";

module.exports = {
  TENANT: 'TENANT',
  CAMPUS: 'CAMPUS',
  DOMAIN: 'DOMAIN',
  PROGRAM: 'PROGRAM'
};